import { computed } from 'vue'
import { useHttp } from '@/shared/lib'
import { useQuery } from '@tanstack/vue-query'

export const useLoadScheduleItem = (scheduleId: number) => {
  const http = useHttp()

  const url = computed(() => {
    return `/schedules/${scheduleId}`
  })

  const queryKey = computed(() => ['schedules_item', scheduleId])

  return useQuery({
    queryKey,
    queryFn: () => http.get(url.value),
    retry: false,
  })
}
